"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _round = _interopRequireDefault(require("lodash/round"));
var _StarOutline = _interopRequireDefault(require("@kyruus/react-ikons/StarOutline"));
var _Star = _interopRequireDefault(require("@kyruus/react-ikons/Star"));
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../lib/constants/messages"));
var _globals = require("../../lib/constants/globals");
var _providerProfileLink = _interopRequireDefault(require("../ProviderProfileLink/provider-profile-link"));
const ProviderRating = _ref => {
  let {
    provider,
    reviewCallback,
    reviewUrl,
    track,
    intl
  } = _ref;
  /**
   * Method to create an array of JSX icons.
   * @param {Component} Icon The Icon to populate the array.
   * @param {number} num The desired length of the icon array.
   * @return {JSX[]} An array with all the icons.
   */
  const iconArrayCreator = (Icon, num) => {
    const icons = [];
    for (let i = 0; i < num; i++) {
      icons.push(/*#__PURE__*/_react.default.createElement(Icon, {
        size: '16px',
        key: `${Icon.displayName}-${i}`
      }));
    }
    return icons;
  };
  const aggregateRatings = provider.reviews && provider.reviews.aggregate_ratings;

  // Get the providers rating rounded to 1 precision point if available.
  const averageRating = aggregateRatings && aggregateRatings.average_rating && (0, _round.default)(aggregateRatings.average_rating, 1).toFixed(1);

  // Get the review count if available.
  const reviewCount = aggregateRatings && aggregateRatings.review_count;

  // Get the rating count if available.
  const ratingCount = aggregateRatings && aggregateRatings.rating_count;

  // Get the rating scale
  const ratingScale = _globals.DEFAULTS.PROVIDER_RATING_SCALE;
  if (provider.reviews) {
    const filledPercent = `${averageRating / (0.01 * ratingScale)}%`;
    return /*#__PURE__*/_react.default.createElement(_styles.RatingsContainer, {
      "data-testid": "ProviderRating"
    }, /*#__PURE__*/_react.default.createElement(_styles.SummaryStars, {
      "aria-label": intl.formatMessage(_messages.default.ariastarratingsaverage, {
        averageRating,
        rating: averageRating
      }),
      ratingScale: ratingScale
    }, /*#__PURE__*/_react.default.createElement(_styles.StarWrapper, null, /*#__PURE__*/_react.default.createElement(_styles.EmptyStars, null, iconArrayCreator(_StarOutline.default, ratingScale)), /*#__PURE__*/_react.default.createElement(_styles.FilledStars, {
      filledPercent: filledPercent
    }, iconArrayCreator(_Star.default, ratingScale)))), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.ratingscale, message => /*#__PURE__*/_react.default.createElement(_styles.AverageRating, null, averageRating, " ", message)), /*#__PURE__*/_react.default.createElement(_providerProfileLink.default, {
      provider: provider,
      pageSection: _globals.LOGGING.PAGE_SECTION.REVIEW_COUNT,
      navCallback: reviewCallback,
      navUrl: reviewUrl,
      track: track,
      "aria-label": intl.formatMessage(_messages.default.ariaproviderreviews, {
        reviewCount
      })
    }, "(", /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.ratingcount, {
      values: {
        ratingCount
      }
    })), ")"));
  } else {
    return null;
  }
};
var _default = exports.default = (0, _intl.injectIntl)(ProviderRating);
ProviderRating.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderRating"
};